import { complianceEndpoints } from './handlers/exampleCompliance';
import { complianceDocumentEndpoints } from './handlers/compliance';
import { complianceDocGeneratorEndpoints } from './handlers/complianceDocGenerator';
import { authEndpoints } from './handlers/auth';
import { imageEndpoints } from './handlers/images';
import { accessControlEndpoints } from './handlers/accessControl';
import { taskEndpoints } from './handlers/task';
import { genericEndpoints } from './handlers/genericData';
import { suppliersEndpoints } from './handlers/suppliers';
import { viewsEndpoints } from './handlers/views';
import { t } from '@lingui/macro';
import { VITE_MOCK_ONLY } from 'config';
import type { Server } from 'miragejs';
import { facilitiesEndpoints } from './handlers/facilities';
import {
  supplierAccessEndpoints,
  supplierGuidedOnboardingEndpoints,
} from './handlers/supplierAccess';
import { purchaseOrdersEndpoints } from './handlers/purchaseOrders';
import { purchaseOrdersMappingEndpoints } from './handlers/purchaseOrdersMapping';
import { purchaseOrdersReviewEndpoints } from './handlers/purchaseOrdersReview';
import { itemsEndpoints } from './handlers/items';
import { stylesEndpoints } from './handlers/styles';
import { organizationIntegrationAccessEndpoints } from './handlers/organizationIntegrationAccess';
import { registerBrandCompaniesEndpoints } from './handlers/brandCompanies';
import { supplierInviteConnectionsEndpoints } from './handlers/supplierInviteConnections';
import { pendingConnectionsEndpoints } from './handlers/pendingConnections';
import { legacyOrgAdminsEndpoints } from './handlers/legacyOrgAdmins';
import { HTTP_RESPONSE_CODES } from '../constants';

const enabledEndpoints = (server: Server) => {
  complianceEndpoints(server);
  imageEndpoints(server);
  accessControlEndpoints(server);
};

const disabledEndpoints = (server: Server) => {
  // CDG mocks are VITE_MOCK_ONLY (vitest/playwright): the dev browser hits the
  // live BE for the compliance-document + doc-generator surfaces (DL-61574).
  complianceDocumentEndpoints(server);
  complianceDocGeneratorEndpoints(server);
  authEndpoints(server);
  suppliersEndpoints(server);
  registerBrandCompaniesEndpoints(server);
  // Brand–Supplier pending connections (dl-61067): VITE_MOCK_ONLY only so
  // live DOMAIN is not shadowed when Mirage starts in the normal browser.
  pendingConnectionsEndpoints(server);
  taskEndpoints(server);
  facilitiesEndpoints(server);
  genericEndpoints(server);
  purchaseOrdersEndpoints(server);
  purchaseOrdersMappingEndpoints(server);
  purchaseOrdersReviewEndpoints(server);
  supplierAccessEndpoints(server);
  viewsEndpoints(server);
  itemsEndpoints(server);
  stylesEndpoints(server);
  organizationIntegrationAccessEndpoints(server);
  // Invite supplier (dl-61766) — VITE_MOCK_ONLY only, never enabledEndpoints.
  supplierInviteConnectionsEndpoints(server);
  supplierGuidedOnboardingEndpoints(server);
  legacyOrgAdminsEndpoints(server);
};

export const endpoints = (server: Server) => {
  enabledEndpoints(server);
  if (VITE_MOCK_ONLY) {
    disabledEndpoints(server);
  }
};

export { HTTP_RESPONSE_CODES };

export const ERROR_MESSAGES = {
  [HTTP_RESPONSE_CODES.NO_CHANGE]: t`204 No change`,
  [HTTP_RESPONSE_CODES.BAD_INPUT]: t`400 Bad input`,
  [HTTP_RESPONSE_CODES.UNAUTHORIZED]: t`'401 User is not authorised`,
  [HTTP_RESPONSE_CODES.BAD_INPUT]: t`403 Action not allowed`,
  [HTTP_RESPONSE_CODES.ENTITY_NOT_FOUND]: t`404 Entity not found`,
  [HTTP_RESPONSE_CODES.SERVER_ERROR]: t`500 Server error`,
};
